export default __webpack_public_path__ + "static/illustration-1-cropped-319fc2ecd9039380370d32b91e3fd64e.png";